import * as React from 'react'
import * as domain from '@packages/domain'
import { constVoid, pipe, RD } from '@packages/prelude'
import { useApi } from '~/api'

export interface UseOptionsResult {
  options: RD.RemoteData<domain.Error.Type, domain.Api.Options.Type>
}

export const useOptions = (): UseOptionsResult => {
  const [loadOptionsQuery, options] = useApi(domain.Api.Options.loadOptions)

  React.useEffect(() => {
    loadOptionsQuery()()
  }, [loadOptionsQuery])

  // a failed options load only hides the dependent controls; log it so the failure is diagnosable
  React.useEffect(() => {
    pipe(
      options,
      RD.match3(constVoid, error => domain.Error.log(error)(), constVoid)
    )
  }, [options])

  return { options }
}
